// layouts/MainLayout/MainLayout.tsx
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import styles from './MainLayout.module.css';

const MainLayout = () => (
  <div className={styles.layout}>
    <Navbar />
    <main className={styles.main}>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default MainLayout;
